import Title from '../components/items/Title'

import me from '../img/me.png'
import gitHub from '../img/gitHub.png'
import linkedin from '../img/linkedin.png'
import instagram from '../img/instagram.png'

import styles from './about.module.css'

export default function About() {
  return (
    <section id="About" className={styles.containerAboutFirst}>
      <div className={styles.titleAbout}>
        <Title title="MUITO PRAZER," subTitle="SOU EDUARDO RICCETTO" />
      </div>
      <div className={styles.containerAbout}>
        <div className={styles.profileAbout}>
          <img src={me} alt="Eduardo Riccetto" />
        </div>
        <div className={styles.textAbout}>
          <h3>
            Desenvolvedor de software com experiência em projetos pela CI&T,
            onde atuei como Software Developer após uma jornada como estagiário.
            Anteriormente, adquiri habilidades em suporte técnico na Desktop
            Sigmanet e em gestão comercial na C&C Casa e Construção.
          </h3>

          <h3>
            Ao longo dos anos, tive o privilégio de contribuir para uma
            variedade de projetos empolgantes, desde o desenvolvimento de
            aplicativos móveis até a criação de sistemas web de grande escala.
            Minhas habilidades técnicas abrangem o desenvolvimento front-end
            utilizando HTML, CSS e JavaScript, bem como frameworks como React.js
            e Angular. No backend, tenho experiência em Node.js e Java com
            SpringBoot. Além disso, possuo experiência em desenvolvimento Mobile
            utilizando React Native, e em bancos de dados SQL e NoSQL, além de
            práticas avançadas de controle de versão com Git e automação de
            testes.
          </h3>

          <h3>
            Formado em Segurança da Informação pela Fatec Americana, estou
            preparado para enfrentar novos desafios no mundo do desenvolvimento
            de software, combinando experiência prática e conhecimento
            acadêmico.
          </h3>
          <div className={styles.containerLink}>
            <a href="https://github.com/RiccettoDev" target="_blank">
              <div className={styles.link}>
                <img src={gitHub} alt="link GitHub" />
              </div>
            </a>
            <a href="https://www.instagram.com/duriccetto/" target="_blank">
              <div className={styles.link}>
                <img src={instagram} alt="link Instagram" />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/in/eduardo-peixoto-riccetto-094a53a2/"
              target="_blank"
            >
              <div className={styles.link}>
                <img src={linkedin} alt="link Linkedin" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
